import React from 'react';
import { Upload, Button, Input, DatePicker, InputNumber, Select, Radio, Cascader } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import API_URL from '../../../common/url';
import { xToken } from '../../../common/AjaxRequest';
import { lowerToUpper } from '../../shared/formatElem';
import { getMatchOption, generateOptions } from '../../shared/selectFn';
import format from '../../shared/format';
import Text from '../../basicElement/Text';
import { Default, MedicineType } from './constants';
import moment from 'moment';

const { Option } = Select;
const { Group } = Radio;
const { TextArea } = Input;
const dateFormat = "YYYY-MM-DD";
const DefaultOption = generateOptions(Default);
const DefaultRadio = generateOptions(Default, 'radio');
const MedicineTypeOption = generateOptions(MedicineType);
const MedicineTypeList = [
    {value: 'Research_drugs', label: '药物'},
    {
        value: 'Technology', 
        label: '技术类',
        children: [
            {
                value: 'Radiation_therapy', 
                label: '放射疗法（同位素 核药；照射）',
            },
            {
                value: 'Cell_therapy', 
                label: '细胞治疗: CART',
            },
            {
                value: 'Stem_cell_therapy', 
                label: '干细胞治疗',
            },
            {
                value: 'Organ_transplant', 
                label: '器官移植',
            },
            {
                value: 'Gene_therapy', 
                label: '基因治疗',
            },
            {
                value: 'Dialysis', 
                label: '透析',
            },
        ]
    },
    {value: 'Medical_instruments', label: '医疗器械'},
    {value: 'Vaccines', label: '疫苗'},
    {value: 'Diagnostic_reagent', label: '诊断试剂'},
    {value: 'Others', label: '其他'},
]

function UpdateUI(props) {
    const {
        Constants,
        saveParams,
        relationContractList,
        sponsorWritable,
        proCodeWritable,
        customerWritable,
        invApplyFinish,
        investigation,
        byStageList,
        currencyList = [], // 币种信息
        belongingToUnitList,
        fileList = [],
        testeeTypeList,
        businessList,
        signingUnitList,
        secondLineIsEmpty,
        handleDelete,
        handleChange,
        beforeUpload,
        handleUploadChange,
        handleChangeRateCanEdit,
        handleRemove,
        rateCanEdit,
        handleEvaluateSelect,
        handleEvaluateBlur,
    } = props;
    saveParams.isRealitySettle=saveParams.contractOrLetterIsSign == 1? saveParams.isRealitySettle?saveParams.isRealitySettle:0:null;
    saveParams.isMsaSpecialContractReduce=saveParams.isRealitySettle == 0?saveParams.isDiscountTermValidity ==1?saveParams.isMsaSpecialContractReduce?saveParams.isMsaSpecialContractReduce:0:null:null;
    const {
        jdeApplyId = '',
        jdeApplyIsInvestigationExists,
        isClinicalProject,
        investigationId,
        contractOrLetterIsSign,
        natureOfContract,
        contractAmount,
        taxationFee,
        rate,
        jdeApplyStatus,
        jdeApplySceneId,
        lineOfBusiness,
        belongingToUnit,
        currencyExchangeRateId,               // 币种编码
        exchangeRate,                         //汇率
        currencyName,                         // 币种名字
        investigationMedicineType,
        investigationByStageId,
        investigationByStageRemark,
        isRealitySettle=0,//是否据实计算
        isMsaSpecialContractReduce=0,//是否从合同中扣减
        isMsaSpecialDiscountCustom, //是否优惠客户
        isDiscountTermValidity, //是否有效期内
        discountContractAmount,
        havePaperContract, //是否拥有纸质合同
    } = saveParams;
    const { blindInvestigationId } = investigation;
    
    // 没选阶段时，单独判断；选择一个时，判断是否是多选项；选择两个以上，默认可多选
    let multiplable = true;
    let showStageOther = false;
    const investigationByStageIds = investigationByStageId ? investigationByStageId.split(',') : [];
    if (investigationByStageIds.length === 1) {
        const { isMultipleChoice, investigationByStageName } = getMatchOption(byStageList, 'investigationByStageId', investigationByStageId);
        multiplable = isMultipleChoice == 1;
        showStageOther = investigationByStageName === '其他';
    }

    const editable = !Constants.edit;
    const scene1Or2 = jdeApplySceneId == 1 || jdeApplySceneId == 2;
    const existPro = jdeApplyIsInvestigationExists == 1 && !scene1Or2;
    const existProHasSelected = jdeApplyIsInvestigationExists != undefined;              // 系统中是否有此项目已选
    const contractHasSelected = contractOrLetterIsSign != undefined;                     // 合同是否签署已选
    const contractHasSigned = contractOrLetterIsSign == '1';                             // 合同已签署
    const isRealitySettleed = isRealitySettle === 0;// 据实结算 否
    const isMsaSpecialContractReduceed = isMsaSpecialContractReduce == '1';// MSA特殊优惠从合同额中扣减
    const isMsaSpecialDiscountCustomed = isMsaSpecialDiscountCustom == 1 ;
    const isDiscountTermValidityed = isDiscountTermValidity == 1 ;
    const isClinicalPro = isClinicalProject == 1;
    const ctaOrFinDisagree = jdeApplyStatus == 'CTA_DISAGREE_APPROVAL_CONTRACT_MONEY' || jdeApplyStatus == 'FIN_DISAGREE_APPROVAL_CONTRACT_MONEY';
    const isAssistantApproval = jdeApplyStatus == 'ASSISTANT_APPROVAL';//CRM合同生成的JDE建号申请 助理审批状态
    const FIRST_CONTRACT = natureOfContract == 'FIRST_CONTRACT';
    const SUPPLEMENT_CONTRACT = natureOfContract == 'SUPPLEMENT_CONTRACT';
    const currencyCode = getMatchOption(currencyList, 'currencyExchangeRateId', currencyExchangeRateId).currencyCode;
    const CNY = currencyCode === 'CNY';
    const isBoundBlind = scene1Or2 && !!blindInvestigationId;
    // 业务机会编号/临床评估单号 显示条件:
    // 新增(无jdeApplyId): 系统中无此项目 且 临床项目; 修改(有jdeApplyId): 场景1或2 且 临床项目
    const showEvaluate = isClinicalProject == 1 && (jdeApplyId ? scene1Or2 : jdeApplyIsInvestigationExists == 0);
    
    let { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);
    // 项目编号包含’遗传办‘或’安全事务‘时，执行业务线二级分类选项只有对应的关键项
    const containHeredity = (saveParams.customerProjectCode || '').includes('遗传办');
    const containSecurityTransaction = (saveParams.customerProjectCode || '').includes('安全事务');
    let disabled = false;
    secondLineList = (secondLineList || []).filter(i => {
        if (isClinicalPro && containHeredity) {
            disabled = true;
            return i.typeValue === '遗传办';
        } else if (isClinicalPro && containSecurityTransaction) {
            disabled = true;
            return i.typeValue === '安全事务';
        } else {
            return true;
        }
    });
    const showSecondLine = (secondLineList || []).length > 0;
    const settings = {};
    let secondLineValue = saveParams.secondLineIds || undefined;
    if (!isClinicalPro) {
        settings.mode = 'multiple';
        secondLineValue = saveParams.secondLineIds ? saveParams.secondLineIds.split(',') : [];
    }

    const relationContractOption = relationContractList.map(i => <Option key={i.investigationJdeContractId} value={i.investigationJdeContractId}>{i.investigationJdeContractCode}</Option>);
    const currencyOption = currencyList.map(i => <Option key={String(i.currencyExchangeRateId)}>{format('joint', i.currencyName, i.currencyCode, 'roundBrackets')}</Option>);
    const signingUnitOptions = signingUnitList.map(i => <Option key={String(i.unitOfSigningId)}>{i.unitOfSigningName}</Option>);
    const belongingToUnitOptions = belongingToUnitList.map(i => <Option key={String(i.unitOfBelongingId)}>{i.unitOfBelongingName}</Option>);
    const testeeTypeOption = testeeTypeList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
    const businessOption = businessList.map(i => <Option key={String(i.typeConfigureId)} disabled={!(i.groupId == 2)}>{i.typeValue}</Option>);
    const secondLineOption = (secondLineList || []).map(i => <Option key={String(i.typeConfigureId)}>{i.typeValue}</Option>);
    const byStageOption = byStageList.map(d => <Option key={String(d.investigationByStageId)} disabled={investigationByStageId ? multiplable ? d.isMultipleChoice == 0 : d.isMultipleChoice == 1 : false}>{d.investigationByStageName}</Option>);

    // 合同税率rate
    let showRateMes = rate ? rate < 6 || rate > 8 : false;
    if( (!rate || rate == '') && (!taxationFee || taxationFee == '') && rateCanEdit) handleChangeRateCanEdit (false);
    if(rateCanEdit == 'rmb') {
        let rateValue = '';
        if ((taxationFee || taxationFee === 0) && (contractAmount || contractAmount === 0)) {
            if (contractAmount - taxationFee == 0) {
                if (contractAmount === 0) {
                    rateValue = 0;
                } else {
                    rateValue = 100;
                }
            } else {
                rateValue = taxationFee / (contractAmount - taxationFee) * 100;
                rateValue = Number.isNaN(rateValue) ? '' : myFixed(rateValue,2);
            }
            if( rateValue != rate && rateValue != '') {
                handleChangeRateCanEdit ('rmb');
                handleChange(rateValue, 'rate', false);
            }
        }
        if(rateValue == '' && rate != null){
            handleChangeRateCanEdit (false);
            handleChange(null, 'rate', false);
        }
    }
    if(rateCanEdit == 'rate') {
        let taxationFeeValue = '';
        if ((rate || rate === 0) && (contractAmount || contractAmount === 0)) {
            taxationFeeValue = contractAmount - contractAmount / ( 1 + rate / 100 );
            taxationFeeValue = Number.isNaN(taxationFeeValue) ? '' : myFixed(taxationFeeValue,2);
            if( taxationFeeValue != taxationFee && taxationFeeValue != '') {
                handleChangeRateCanEdit ('rate');
                handleChange(taxationFeeValue, 'taxationFee', false);
            }
        }
        if(taxationFeeValue == '' && taxationFee != null){
            handleChangeRateCanEdit (false);
            handleChange(null, 'taxationFee', false);
        }
    }
    
    //优惠金额（不含税）
    let discountContractAmountNoTaxValue ='';
    if((discountContractAmount || discountContractAmount == 0)&& (rate || rate == 0)){
        discountContractAmountNoTaxValue = discountContractAmount*(1-rate/100);
        discountContractAmountNoTaxValue = Number.isNaN(discountContractAmountNoTaxValue) ? '' : myFixed(discountContractAmountNoTaxValue,2)
        // handleChange(discountContractAmountNoTaxValue, 'discountContractAmountNoTax')
    }

    function myFixed(num, digit) {
            if(Object.is(parseFloat(num), NaN)) {
            return console.log(`传入的值：${num}不是一个数字`);
            }
            num = parseFloat(num);
            return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit);
        }

    function getContractDom(key, width, disabled = true) {
        return (
            <InputNumber
                maxLength="17"
                precision={2}
                disabled={!disabled}
                placeholder="请输入"
                max={99999999999}
                style={{ width }}
                value={saveParams[key]}
                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={value => value.replace(/\￥\s?|(,*)/g, '')}
                onChange={value => handleChange(value, key)}
                />
        );
    }
    //判断用户是否是特殊优惠客户和是否在优惠有效期内
    function customerCompanyChange(value){
        const MsaSpecialDiscountCustom=value.isMsaSpecialDiscountCustom;
        const DiscountTermValidity=value.isDiscountTermValidity;
        handleChange(MsaSpecialDiscountCustom, 'isMsaSpecialDiscountCustom')
        handleChange(DiscountTermValidity, 'isDiscountTermValidity')
    }

    const{customerCompanyName="",customerCompanySpecialName=""}=saveParams;
    const JDECustomerCompanyNameErr = (customerCompanyName&&(!customerCompanySpecialName));//Bug28689，所有情形须有简称
    return (
        <div>
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label"><Text asterisk={editable}>系统中是否有此项目</Text></label>
                    <span className="ui-text">
                        {
                            editable ?
                                <Select
                                    placeholder="请选择"
                                    style={{ width: 182 }}
                                    value={jdeApplyIsInvestigationExists}
                                    getPopupContainer={() => document.getElementById('dropdown-position')}
                                    onChange={value => handleChange(value, 'jdeApplyIsInvestigationExists')}
                                >
                                    { DefaultOption }
                                </Select>
                            :
                                jdeApplyIsInvestigationExists != undefined ? jdeApplyIsInvestigationExists == 1 ? '是' : '否' : ''
                        }
                    </span>
                </div>
            </li>
            {
                jdeApplyIsInvestigationExists == 1 &&
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label"><Text asterisk={editable}>项目简称</Text></label>
                        <span className="ui-text">
                            {
                                editable ?
                                    <SearchRetrieve
                                        keyword='investigationName'
                                        style={{ width: 182 }}
                                        placeholder="输入项目简称/编号检索"
                                        value={saveParams.investigationName}
                                        params={{ limit: 20, noFinished: true }}
                                        url={API_URL.investigation.queryInvestigationByName}
                                        config={{ id: 'investigationId', name: 'investigationName' }}
                                        onChange={(option) => handleChange(option, 'investigation')}
                                        getPopupContainer={() => document.getElementById('dropdown-position')}
                                    />
                                :
                                    saveParams.investigationName
                            }
                        </span>
                    </div>
                </li>
            }
            {
                existProHasSelected &&
                <li className="preview-item">
                    <div className="item">
                        {/* 不存在项目时，必选；存在时，取项目中的值 */}
                        <label className="ui-label"><Text asterisk={!existPro}>此项目是否为临床项目</Text></label>
                        <span className="ui-text">
                            {
                                !existPro ?
                                    <Select
                                        placeholder="请选择"
                                        style={{ width: 182 }}
                                        value={isClinicalProject}
                                        disabled={isBoundBlind}
                                        getPopupContainer={() => document.getElementById('dropdown-position')}
                                        onChange={value => handleChange(value, 'isClinicalProject')}
                                    >
                                        { DefaultOption }
                                    </Select>
                                :
                                    Default[isClinicalProject]
                            }
                        </span>
                    </div>
                </li>
            }
            {
                /* 业务机会编号/临床评估单号 显示条件见 showEvaluate: 新增-系统无此项目且临床项目; 修改-场景1或2且临床项目 */
                showEvaluate &&
                <div>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={true}>业务机会编号</Text></label>
                            <span className="ui-text">
                                <span onBlur={handleEvaluateBlur}>
                                    <SearchRetrieve
                                        keyword='busOppNum'
                                        style={{ width: 182 }}
                                        placeholder="输入检索"
                                        value={saveParams.busOppNum}
                                        url={API_URL.contract.queryEvaluateForAddJdeApply}
                                        config={{ id: 'businessOpportunityNum', name: 'businessOpportunityNum' }}
                                        onChange={handleEvaluateSelect}
                                        getPopupContainer={() => document.getElementById('dropdown-position')}
                                    />
                                </span>
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={true}>临床评估单号</Text></label>
                            <span className="ui-text">
                                <span onBlur={handleEvaluateBlur}>
                                    <SearchRetrieve
                                        keyword='evaluateCode'
                                        style={{ width: 182 }}
                                        placeholder="输入检索"
                                        value={saveParams.evaluateCode}
                                        url={API_URL.contract.queryEvaluateForAddJdeApply}
                                        config={{ id: 'evaluateCode', name: 'evaluateCode' }}
                                        onChange={handleEvaluateSelect}
                                        getPopupContainer={() => document.getElementById('dropdown-position')}
                                    />
                                </span>
                            </span>
                        </div>
                    </li>
                </div>
            }
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label"><Text asterisk={editable}>合同或函证是否签署</Text></label>
                    <span className="ui-text">
                        {
                            editable ?
                                <Select
                                    placeholder="请选择"
                                    style={{ width: 182 }}
                                    value={contractOrLetterIsSign}
                                    getPopupContainer={() => document.getElementById('dropdown-position')}
                                    onChange={value => handleChange(value, 'contractOrLetterIsSign')}
                                >
                                    { DefaultOption }
                                </Select>
                            :
                                Default[contractOrLetterIsSign]
                        }
                    </span>
                </div>
            </li>
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label"><Text asterisk={editable}>合同性质</Text></label>
                    <span className="ui-text">
                        {
                            editable ?
                                <Select
                                    placeholder="请选择"
                                    style={{ width: 182 }}
                                    value={natureOfContract}
                                    getPopupContainer={() => document.getElementById('dropdown-position')}
                                    onChange={value => handleChange(value, 'natureOfContract')}
                                >
                                    <Option value='FIRST_CONTRACT'>首次合同</Option>
                                    {existPro && <Option value='SUPPLEMENT_CONTRACT'>补充合同</Option>}
                                    {existPro && <Option value='RENEW_CONTRACT'>续签合同</Option>}
                                    {existPro && <Option value='TERMINATION_CONTRACT' disabled={!investigationId}>终止合同</Option>}
                                    {existPro && <Option value='TERMINATION_LETTER' disabled={!investigationId}>终止函</Option>}
                                </Select>
                            :
                                saveParams.natureOfContractShow
                        }
                    </span>
                </div>
            </li>
            {
                contractHasSelected &&
                <div>
                    {
                        existPro &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label"><Text asterisk={natureOfContract && !FIRST_CONTRACT}>关联JDE</Text></label>
                                <span className="ui-text">
                                    <Select
                                        placeholder="请选择"
                                        style={{ width: 182 }}
                                        getPopupContainer={() => document.getElementById('dropdown-position')}
                                        onSelect={value => handleChange(value, 'relationJdeId')}
                                        onChange={value => handleDelete(value, 'relationJdeId')}
                                        disabled={!(investigationId && natureOfContract)}
                                        value={saveParams.relationJdeId}
                                        optionFilterProp="children"
                                        showSearch={true}
                                        allowClear={true}
                                    >
                                        {relationContractOption}
                                    </Select>
                                </span>
                            </div>
                        </li>
                    }
                    <li className="preview-item">
                        {/* 不存在项目；存在项目，但不是首次合同，且不显示文本时 可编辑 */}
                        <div className="item">
                            <label className="ui-label"><Text asterisk={!existPro || (natureOfContract && !FIRST_CONTRACT && sponsorWritable)}>合同签署方</Text></label>
                            <span className="ui-text">
                                {
                                    (!existPro || (natureOfContract && !FIRST_CONTRACT && sponsorWritable)) ?
                                        <SearchRetrieve
                                            keyword='customerCompanyName'
                                            style={{ width: 182 }}
                                            placeholder="输入名称检索"
                                            params={{ limit: 20 }}
                                            value={saveParams.contractSignCompanyName}
                                            disabled={isBoundBlind}
                                            url={API_URL.investigation.queryCustomerCompanyByName}
                                            config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                            onChange={(option) => handleChange(option, 'contractSignCompany')}
                                            getPopupContainer={() => document.getElementById('dropdown-position')}
                                        />
                                    :
                                        saveParams.contractSignCompanyName
                                }
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={false}>项目识别码</Text></label>
                            <span className="ui-text">
                                {
                                    jdeApplyIsInvestigationExists != 1 ?
                                    <SearchRetrieve
                                        keyword='identifyCode'
                                        style={{ width: 182 }}
                                        placeholder="输入名称检索"
                                        value={saveParams.investigationIdentifyCode}
                                        params={{ limit: 20 }}
                                        url={API_URL.contract.queryInvIdentifyCodeList}
                                        config={{ id: 'investigationIdentifyCodeId', name: 'identifyCode' }}
                                        onChange={(option) => handleChange(option, 'investigationIdentifyCode')}
                                    />
                                :
                                    saveParams.investigationIdentifyCode
                                }
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={!existPro || (natureOfContract && !FIRST_CONTRACT && proCodeWritable)}>项目编号</Text></label>
                            <span className="ui-text">
                                {
                                    (!existPro || (natureOfContract && !FIRST_CONTRACT && proCodeWritable)) ?
                                        <Input
                                            placeholder="请输入"
                                            style={{ width: 182 }}
                                            value={saveParams.customerProjectCode}
                                            onChange={e => handleChange(e.target.value, 'customerProjectCode')}
                                        />
                                    :
                                        saveParams.customerProjectCode
                                }
                                { !existPro && <span style={{ whiteSpace: 'nowrap', color: '#F00' }}><br />（如果是遗传办、安全事务等项目，请在项目编号中注明）</span> }
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={FIRST_CONTRACT || SUPPLEMENT_CONTRACT || customerWritable}>客户全名</Text></label>
                            <span className="ui-text">
                                {
                                    (FIRST_CONTRACT || SUPPLEMENT_CONTRACT || customerWritable) ?
                                        <SearchRetrieve
                                            keyword='customerCompanyName'
                                            style={{ width: 182 }}
                                            placeholder="输入名称检索"
                                            params={{ limit: 20 }}
                                            value={saveParams.customerCompanyName}
                                            url={API_URL.investigation.queryCustomerCompanyByName}
                                            config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                            onChange={(option) => {
                                                handleChange(option, 'customerCompany');
                                                customerCompanyChange(option)}}
                                            getPopupContainer={() => document.getElementById('dropdown-position')}
                                        />
                                    :
                                        saveParams.customerCompanyName
                                }
                                 { JDECustomerCompanyNameErr && <span style={{ whiteSpace: 'nowrap', color: '#F00' }}><br />（当前客户未维护客户简称，请联系管理员维护其客户简称）</span> }
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label">客户JDE号</label>
                            <span className="ui-text">{saveParams.customerJdeCode}</span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={true}>BA</Text></label>
                            <span className="ui-text">
                                <SearchRetrieve
                                    keyword='keyWord'
                                    style={{ width: 182 }}
                                    placeholder="输入姓名/工号检索"
                                    value={saveParams.baUserName}
                                    params={{ limit: 20, roleCodes: 'BA,BAL' }}
                                    url={API_URL.teaching.queryEmpListByRoleCode}
                                    config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                    onChange={(option) => handleChange(option, 'baUser')}
                                    getPopupContainer={() => document.getElementById('dropdown-position')}
                                />
                            </span>
                        </div>
                    </li>
                    {
                        (!existPro || scene1Or2) &&
                        <div>
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label"><Text asterisk={true}>研究产品类型</Text></label>
                                    <span className="ui-text">
                                        <Cascader
                                            allowClear={true}
                                            placeholder="请选择"
                                            style={{ width: 182 }}
                                            disabled={isBoundBlind}
                                            options={MedicineTypeList}
                                            value={investigationMedicineType || undefined}
                                            onChange={value => handleChange(value, 'investigationMedicineType')}
                                        />
                                    </span>
                                </div>
                            </li>
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label"><Text asterisk={true}>项目分期</Text></label>
                                    <span className="ui-text">
                                        <Select
                                            mode="multiple"
                                            allowClear={true}
                                            placeholder="请选择"
                                            style={{ width: 182 }}
                                            disabled={isBoundBlind}
                                            value={investigationByStageIds}
                                            getPopupContainer={() => document.getElementById('dropdown-position')}
                                            onChange={value => handleChange(value, 'investigationByStageId')}
                                        >
                                            {byStageOption}
                                        </Select>
                                    </span>
                                </div>
                            </li>
                            {
                                showStageOther &&
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label clearAfter"><Text asterisk={true}>其他项目分期备注</Text></label>
                                        <span className="ui-text">
                                            <Input
                                                maxLength="200"
                                                placeholder="请输入备注"
                                                style={{ width: 182 }}
                                                disabled={isBoundBlind}
                                                value={investigationByStageRemark}
                                                onChange={e => handleChange(e.target.value, 'investigationByStageRemark')}
                                            />
                                        </span>
                                    </div>
                                </li>
                            }
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label"><Text asterisk={true}>疾病</Text></label>
                                    <span className="ui-text">
                                        <SearchRetrieve
                                            keyword='keyword'
                                            style={{ width: 182 }}
                                            placeholder="输入名称检索"
                                            disabled={isBoundBlind}
                                            value={saveParams.diseaseName}
                                            params={{ limit: 20, investigationMedicineType }}
                                            url={API_URL.common.queryAllDiseaseList}
                                            config={{ id: 'diseaseId', name: 'diseaseName', show: 'disease' }}
                                            onChange={(option) => handleChange(option, 'disease')}
                                            getPopupContainer={() => document.getElementById('dropdown-position')}
                                        />
                                    </span>
                                </div>
                            </li>
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label">疾病分类</label>
                                    <span className="ui-text">{saveParams.diseaseClassName}</span>
                                </div>
                            </li>
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label">项目领域</label>
                                    <span className="ui-text">{saveParams.investigationAreaName}</span>
                                </div>
                            </li>
                        </div>
                    }
                    {
                        //系统中已有项目时 助理审批状态修改 也展示受试者类型(补填后才能助理审批)
                        ((!existPro || scene1Or2) || isAssistantApproval) &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label"><Text asterisk={true}>受试者类型</Text></label>
                                <span className="ui-text">
                                    <Select
                                        allowClear={true}
                                        placeholder="请选择"
                                        style={{ width: 182 }}
                                        disabled={isBoundBlind}
                                        value={saveParams.testeeTypeId || undefined}
                                        getPopupContainer={() => document.getElementById('dropdown-position')}
                                        onChange={value => handleChange(value, 'testeeTypeId')}
                                    >
                                        {testeeTypeOption}
                                    </Select>
                                </span>
                            </div>
                        </li>
                    }
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={!existPro && !isClinicalPro}>业务线</Text></label>
                            <span className="ui-text">
                                {
                                    (!existPro && !isClinicalPro)  ?
                                        <Select
                                            allowClear={true}
                                            placeholder="请选择"
                                            style={{ width: 182 }}
                                            disabled={isBoundBlind}
                                            value={lineOfBusiness ? String(lineOfBusiness) : undefined}
                                            getPopupContainer={() => document.getElementById('dropdown-position')}
                                            onChange={value => handleChange(value, 'lineOfBusiness')}
                                        >
                                            {businessOption}
                                        </Select>
                                    :
                                        saveParams.lineOfBusinessString
                                }
                            </span>
                        </div>
                    </li>
                    {
                        showSecondLine &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label"><Text asterisk={(!existPro || secondLineIsEmpty)}>执行业务线二级分类</Text></label>
                                <span className="ui-text">
                                    {
                                        (!existPro || secondLineIsEmpty) ?
                                            <Select
                                                allowClear={true}
                                                placeholder="请选择"
                                                style={{ width: 182 }}
                                                value={secondLineValue}
                                                disabled={disabled || isBoundBlind}
                                                getPopupContainer={() => document.getElementById('dropdown-position')}
                                                onChange={value => handleChange(value, 'secondLineIds')}
                                                {...settings}
                                            >
                                                {secondLineOption}
                                            </Select>
                                        :
                                            saveParams.secondLineNames
                                    }
                                </span>
                            </div>
                        </li>
                    }
                    {
                        (!existPro || scene1Or2) &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">项目分类</label>
                                <span className="ui-text">{saveParams.investigationTypeName}</span>
                            </div>
                        </li>
                    }
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={true}>合同签署单位</Text></label>
                            <span className="ui-text">
                                <Select
                                    allowClear={true}
                                    placeholder="请选择"
                                    style={{ width: 182 }}
                                    value={saveParams.signingUnit ? String(saveParams.signingUnit) : undefined}
                                    getPopupContainer={() => document.getElementById('dropdown-position')}
                                    onChange={value => handleChange(value, 'signingUnit')}
                                >
                                    {signingUnitOptions}
                                </Select>
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={true}>收入归属单位</Text></label>
                            <span className="ui-text">
                                <Select
                                    allowClear={true}
                                    placeholder="请选择"
                                    style={{ width: 182 }}
                                    disabled={!saveParams.signingUnit}
                                    value={belongingToUnit ? String(belongingToUnit) : undefined}
                                    getPopupContainer={() => document.getElementById('dropdown-position')}
                                    onChange={value => handleChange(value, 'belongingToUnit')}
                                >
                                    {belongingToUnitOptions}
                                </Select>
                            </span>
                        </div>
                    </li>
                    {
                        contractHasSigned &&
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label"><Text asterisk={true}>合同中是否明标合同金额</Text></label>
                                <span className="ui-text">
                                    <Group onChange={e => handleChange(e.target.value, 'contractIsSpecifiesAmount')} value={saveParams.contractIsSpecifiesAmount}>
                                        { DefaultRadio }
                                    </Group>
                                </span>
                            </div>
                        </li>
                    }
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={true}>币种</Text></label>
                            <span className="ui-text">
                                <Select
                                    placeholder="请选择"
                                    style={{ width: 182 }}
                                    value={currencyExchangeRateId ? String(currencyExchangeRateId) : undefined}
                                    getPopupContainer={() => document.getElementById('dropdown-position')}
                                    onChange={value => handleChange(value, 'currencyExchangeRateId')}
                                >
                                    {currencyOption}
                                </Select>
                            </span>
                        </div>
                    </li>
                    <li className="preview-item">
                        <div className="item">
                            <label className="ui-label"><Text asterisk={!CNY}>汇率</Text></label>
                            <span className="ui-text">
                                {
                                    !CNY ?
                                        <InputNumber
                                            placeholder="请输入"
                                            style={{ width: 182 }}
                                            value={exchangeRate}
                                            onChange={value => handleChange(value, 'exchangeRate')}
                                        />
                                    :
                                        exchangeRate
                                }
                            </span>
                        </div>
                        {
                            (!CNY && currencyName && Constants.edit) &&
                            <div style={{ clear: 'both', marginLeft: 225, paddingTop: 10, color: 'blue' }}>【{saveParams.dateShow}: 1{currencyName}={saveParams.currencyExchangeRate}人民币】</div>
                        }
                    </li>
                    {
                        !contractHasSigned ?
                            CNY ?
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label"><Text asterisk={true}>预计合同金额/人民币</Text></label>
                                        <span className="ui-text">
                                            {getContractDom('expectContractAmount', 182)}&nbsp;元
                                        </span>
                                    </div>
                                    {lowerToUpper(saveParams.expectContractAmount, 230)}
                                </li>
                            :
                                <div className="jde-rate">
                                    <div className="left" style={{ width: '50%' }}>
                                        <div className="left lable" style={{ width: '50%' }}><Text asterisk={true}>预计合同金额/原币</Text></div>
                                        <div className="right text-com" style={{ width: '50%' }}>
                                            {getContractDom('expectContractAmount', 100)}&nbsp;{currencyName}
                                        </div>
                                    </div>
                                    <div className="right" style={{ width: '50%' }}>
                                        <div className="left lable" style={{ width: '50%' }}>预计合同金额/人民币</div>
                                        <div className="right text-com" style={{ width: '50%' }}>
                                            {format('money', saveParams.expectContractAmount, exchangeRate)}&nbsp;元
                                        </div>
                                    </div>
                                </div>
                        :
                            CNY ?
                                <div>
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label"><Text asterisk={true}>合同额含税/人民币</Text></label>
                                            <span className="ui-text">
                                                {getContractDom('contractAmount', 182)}&nbsp;元
                                            </span>
                                        </div>
                                    </li>
                                    {lowerToUpper(saveParams.contractAmount, 245)}
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label"><Text asterisk={true}>合同税率</Text></label>
                                            <span className="ui-text">
                                                {getContractDom('rate', 182, !rateCanEdit || rateCanEdit == 'rate')} &nbsp;%
                                                {
                                                    showRateMes && <span style={{ color: 'red', padding: '0 10px' }}>税率范围：6%~8%</span>
                                                }
                                            </span>
                                        </div>
                                    </li>
                                    <div className="FeeBackground" style={{ width: '80%' }}>
                                        <div style={{ position: 'absolute', top: 0, left: 0, right: '88%', bottom: 0, background: '#f9f9f9', borderRight: "1px solid #ccc" }}>
                                            <span style={{ position: "absolute", left: "10px", top: "50%", transform: 'translateY(-50%)' }}>&nbsp;其中<br />需扣除</span>
                                        </div>
                                        <div style={{ height: "100%", marginLeft: '12%' }}>
                                            <li className="preview-item">
                                                <div className="item">
                                                    <label className="ui-label">实报实销(不含税)/人民币</label>
                                                    <span className="ui-text">
                                                        {getContractDom('actualExpenseFee', 182)}&nbsp;元
                                                    </span>
                                                </div>
                                            </li>
                                            {lowerToUpper(saveParams.actualExpenseFee)}
                                            <li className="preview-item">
                                                <div className="item">
                                                    <label className="ui-label">实报实销税费/人民币</label>
                                                    <span className="ui-text">
                                                        {getContractDom('actualFee', 182)}&nbsp;元
                                                    </span>
                                                </div>
                                            </li>
                                            {lowerToUpper(saveParams.actualFee)}
                                            <li className="preview-item">
                                                <div className="item">
                                                    <label className="ui-label"><Text asterisk={true}>合同额税费/人民币</Text></label>
                                                    <span className="ui-text">
                                                        {getContractDom('taxationFee', 182, !rateCanEdit || rateCanEdit == 'rmb')}&nbsp;元
                                                    </span>
                                                </div>
                                            </li>
                                            {lowerToUpper(saveParams.taxationFee)}
                                        </div>
                                    </div>
                                </div>
                            :
                                <div className="jde-rate">
                                    <div>
                                        <div className="left" style={{ width: '55%' }}>
                                            <div className="left lable" style={{ width: '59.4%' }}><Text asterisk={true}>合同额含税/原币</Text></div>
                                            <div className="right text-com" style={{ width: '40.6%' }}>
                                                {getContractDom('contractAmount', 100)}&nbsp;{currencyName}
                                            </div>
                                        </div>
                                        <div className="right" style={{ width: '45%' }}>
                                            <div className="left lable" style={{ width: '50%' }}>合同额含税/人民币</div>
                                            <div className="right text-com" style={{ width: '50%' }}>
                                                {format('money', saveParams.contractAmount, exchangeRate)}&nbsp;元
                                                </div>
                                        </div>
                                    </div>
                                    <div className="jde-top">
                                        <div className="left lable" style={{ width: '10%', textAlign: 'center', borderRight: 0 }}>其中<br />需扣除</div>
                                        <div className="right jde-left" style={{ width: '90%' }}>
                                            <div>
                                                <div className="left" style={{ width: '50%' }}>
                                                    <div className="left lable" style={{ width: '50%' }}>实报实销(不含税)/原币</div>
                                                    <div className="right text-com" style={{ width: '50%' }}>
                                                        {getContractDom('actualExpenseFee', 100)}&nbsp;{currencyName}
                                                    </div>
                                                </div>
                                                <div className="right" style={{ width: '50%' }}>
                                                    <div className="left lable" style={{ width: '50%' }}>实报实销(不含税)/人民币</div>
                                                    <div className="right text-com" style={{ width: '50%' }}>
                                                        {format('money', saveParams.actualExpenseFee, exchangeRate)}&nbsp;元
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="jde-bottom">
                                                <div className="left" style={{ width: '50%' }}>
                                                    <div className="left lable" style={{ width: '50%' }}>实报实销税费/原币</div>
                                                    <div className="right text-com" style={{ width: '50%' }}>
                                                        {getContractDom('actualFee', 100)}&nbsp;{currencyName}
                                                    </div>
                                                </div>
                                                <div className="right" style={{ width: '50%' }}>
                                                    <div className="left lable" style={{ width: '50%' }}>实报实销税费/人民币</div>
                                                    <div className="right text-com" style={{ width: '50%' }}>
                                                        {format('money', saveParams.actualFee, exchangeRate)}&nbsp;元
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="jde-bottom">
                                                <div className="left" style={{ width: '50%' }}>
                                                    <div className="left lable" style={{ width: '50%' }}><Text asterisk={true}>合同额税费/原币</Text></div>
                                                    <div className="right text-com" style={{ width: '50%' }}>
                                                        {getContractDom('taxationFee', 100, !rateCanEdit || rateCanEdit == 'rmb')}&nbsp;元
                                                    </div>
                                                </div>
                                                <div className="right" style={{ width: '50%' }}>
                                                    <div className="left lable" style={{ width: '50%' }}>合同额税费/人民币</div>
                                                    <div className="right text-com" style={{ width: '50%' }}>
                                                        {format('money', saveParams.taxationFee, exchangeRate)}&nbsp;元
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="jde-top">
                                        <div className="left lable" style={{ width: '32.6%' }}><Text asterisk={true}>合同税率</Text></div>
                                        <div className="right text-com" style={{ width: '67.4%' }}>
                                            {getContractDom('rate', 100, !rateCanEdit || rateCanEdit == 'rate')} &nbsp;%
                                            {
                                                showRateMes && <span style={{ color: 'red', padding: '0 10px' }}>税率范围：6%~8%</span>
                                            }
                                        </div>
                                    </div>
                                </div>
                    }
                    {
                        contractHasSigned &&
                        <div>
                            {
                                FIRST_CONTRACT && saveParams.relationJdeId &&
                                <li className="preview-item">
                                    <div className="item">
                                        <label className="ui-label"><Text asterisk={true}>关联JDE是否需要扣除相应金额</Text></label>
                                        <span className="ui-text">
                                            <Group onChange={e => handleChange(e.target.value, 'relateJdeIsDeductAmount')} value={saveParams.relateJdeIsDeductAmount}>
                                                { DefaultRadio }
                                            </Group>
                                        </span>
                                    </div>
                                </li>
                            }
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label"><Text asterisk={true}>是否据实结算</Text></label>
                                    <span className="ui-text">
                                        <Group onChange={e => handleChange(e.target.value, 'isRealitySettle')} value={isRealitySettle}>
                                            <Radio key={1} value={1}>是</Radio>
                                            <Radio key={0} value={0}>否</Radio>
                                        </Group>
                                    </span>
                                </div>
                            </li>
                            {
                                (isRealitySettleed && isDiscountTermValidityed) &&
                                <div>
                                    <li className="preview-item">
                                        <div className="item">
                                            <label className="ui-label" style={{padding:'0'}}><Text asterisk={true}>MSA特殊优惠是否从合同额中扣减</Text></label>
                                            <span className="ui-text">
                                                <Group onChange={e => handleChange(e.target.value, 'isMsaSpecialContractReduce')} value={isMsaSpecialContractReduce}>
                                                    <Radio key={1} value={1}>是</Radio>
                                                    <Radio key={0} value={0}>否</Radio>
                                                </Group>
                                            </span>
                                        </div>
                                    </li>
                                    {
                                        isMsaSpecialContractReduceed && 
                                            <div>
                                                <li className="preview-item">
                                                    <div className="item">
                                                        <label className="ui-label"><Text asterisk={true}>优惠金额（含税）/人民币</Text></label>
                                                        <span className="ui-text">
                                                            {getContractDom('discountContractAmount', 182)}&nbsp;元
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className="preview-item">
                                                    <div className="item">
                                                        <label className="ui-label">优惠金额（不含税）/人民币</label>
                                                        <span className="ui-text" style={{ width: 186 }}>
                                                            {discountContractAmountNoTaxValue}&nbsp;元
                                                        </span>
                                                    </div>
                                                </li>
                                            </div>
                                    }
                                </div>
                            }
                            
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label"><Text asterisk={true}>合同开始时间</Text></label>
                                    <span className="ui-text">
                                        <DatePicker
                                            placeholder="请选择"
                                            style={{ width: 182 }}
                                            format={dateFormat}
                                            value={saveParams.contractStartDate ? moment(saveParams.contractStartDate) : null}
                                            onChange={(date, dateString) => handleChange(dateString, "contractStartDate")}
                                        />
                                    </span>
                                </div>
                            </li>
                            <li className="preview-item">
                                <div className="item">
                                    <label className="ui-label"><Text asterisk={true}>合同结束时间</Text></label>
                                    <span className="ui-text">
                                        <DatePicker
                                            placeholder="请选择"
                                            style={{ width: 182 }}
                                            format={dateFormat}
                                            value={saveParams.contractEndDate ? moment(saveParams.contractEndDate) : null}
                                            onChange={(date, dateString) => handleChange(dateString, "contractEndDate")}
                                        />
                                    </span>
                                </div>
                            </li>
                        </div>
                    }
                </div>
            }
            {
                (natureOfContract == 'TERMINATION_CONTRACT' || natureOfContract == 'TERMINATION_LETTER') &&
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label"><Text asterisk={!invApplyFinish}>项目终止原因</Text></label>
                        <span className="ui-text">
                            {
                                !invApplyFinish ?
                                    <Input
                                        maxLength="200"
                                        placeholder="请输入"
                                        style={{ width: 182 }}
                                        value={saveParams.terminationReason}
                                        onChange={e => handleChange(e.target.value, 'terminationReason')}
                                    />
                                :
                                    saveParams.terminationReason
                            }
                        </span>
                    </div>
                </li>
            }
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label">备注</label>
                    <span className="ui-text">
                        {
                            ctaOrFinDisagree && (jdeApplySceneId == 1 || jdeApplySceneId == 4 || jdeApplySceneId == 7) ?
                                saveParams.contractRelationSiteComment
                            :
                                <TextArea
                                    value={saveParams.contractRelationSiteComment}
                                    placeholder="请输入"
                                    style={{ width: 300, height: 80 }}
                                    onChange={e => handleChange(e.target.value, 'contractRelationSiteComment')}
                                />
                        }
                    </span>
                </div>
            </li>
            <li className="preview-item">
                <div className="item">
                    <label className="ui-label" style={{padding:'0'}}><Text asterisk={true}>是否拥有纸质合同</Text></label>
                    <span className="ui-text">
                        <Group onChange={e => handleChange(e.target.value, 'havePaperContract')} value={havePaperContract}>
                            <Radio key={1} value={1}>是</Radio>
                            <Radio key={0} value={0}>否</Radio>
                        </Group>
                    </span>
                </div>
            </li>
            {
                contractHasSelected &&
                <li className="preview-item">
                    <div className="item">
                        <label className="ui-label"><Text asterisk={true}>{ contractHasSigned ? '上传附件' : '提前上岗授权函' }</Text></label>
                        <span className="ui-text">
                            <Upload
                                action={API_URL.contract.uploadJdeCodeEnclosure}
                                data={{
                                    path: Date.now(),
                                    jdeApplyId: Constants.copy ? '' : jdeApplyId,
                                    uploadType: contractHasSigned ? 'CONTRACT' : 'ADVANCE_WORK',
                                    curUserId: sessionStorage.userId,
                                    curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                }}
                                beforeUpload={beforeUpload}
                                onChange={handleUploadChange}
                                onRemove={handleRemove}
                                fileList={fileList}
                                headers={xToken}
                            >
                                <Button style={{ width: 80 }}>选择文件</Button>
                            </Upload>
                        </span>
                    </div>
                </li>
            }
        </div>
    );
}

export default UpdateUI;


// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/UpdateUI.js